$(document).ready(function () {
    updateHeaderBg();
    handlerMenu();
    initLang();
    $('h3.product-details').click(function () {
        new bootstrap.Collapse($(this).data('target'))
    });
    $('.btn-collapse-product').click(function () {
        new bootstrap.Collapse($(this).data('target'))
    });
    window.authentication = async function () {
        if (window.customer && window.BackendUrl) {
            return fetch(`${window.BackendUrl}/customer/auth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: window.customer.email,
                    id: window.customer.id,
                    name: window.customer.first_name + " " + window.customer.last_name
                })
            }).then(response => response.json())
                .then(data => {
                    if (data && data.success && data.body && data.body.token) {
                        localStorage.setItem('token', data.body.token);
                        localStorage.setItem('token_expire', Date.now() + 60 * 60 * 1000);
                        window.customerToken = customerToken();
                        return data.body.token;
                    }
                    else {
                        localStorage.removeItem('token');
                        localStorage.removeItem('token_expire');
                        return undefined;
                    }
                })
                .catch(error => {
                    console.error('Error:');
                    console.error(error);
                    return undefined;
                });
        }
        else {
            localStorage.removeItem('token');
            localStorage.removeItem('token_expire');
            return undefined;
        }
    }
    function isAuthenticated() {
        if (window.customer && window.BackendUrl) {
            var token_expire = localStorage.getItem('token_expire');
            var token = localStorage.getItem('token');
            if (token && token.length > 10 && token_expire && Date.now() < token_expire) {
                return true;
            }
        }
        return false;
    }
    window.isAuthenticated = isAuthenticated();
    function customerToken() {
        if (window.customer && window.BackendUrl) {
            var token_expire = localStorage.getItem('token_expire');
            var token = localStorage.getItem('token');
            if (token && token.length > 10 && token_expire && Date.now() < token_expire) {
                return token;
            }
        }
        return '';
    }

    window.getToken = async function () {
        var token = customerToken();

        if (!token) {
            return window.authentication();
        }
        return token;
    }

    setTimeout(function () {
        initTooltip();
    }, 1000)
    if ($('#hilx-header').length > 0) {

        $('sticky-header').on("mouseleave", function () {
            updateHeaderBg();
        })

        $('.header__menu-block').on("mouseenter", function () {
            if ($(this).hasClass('is-parent-false')) {

                $('.mega-menu__content').removeClass('is-hover');
            }
            else {
                $('#hilx-header').addClass('white-header');
                $('.mega-menu__content').css('z-index', 1);
                var currentMega = $(this).find('.mega-menu__content');
                currentMega.css('z-index', 2)
                currentMega.addClass('is-hover');
                setTimeout(function () {
                    $('.mega-menu__content').each(function () {
                        if ($(currentMega).attr('id') != $(this).attr('id')) {
                            $(this).removeClass('is-hover');
                        }
                    })
                }, 200)
            }
        });
        $('.header__menu-item').on("mouseenter", function () {
            $('.header__menu-item').removeClass('is-hover');
            $(this).addClass('is-hover');
        });
    }
    var token_expire = localStorage.getItem('token_expire');
    if (!token_expire || (token_expire && Date.now() > token_expire)) {
        window.authentication();
    }
})
$(document).on('scroll', function (e) {
    if ($('#hilx-announcement-bar').length > 0) {
        if ($(this).scrollTop() > 0) {
            $('#hilx-announcement-bar').slideUp(100, function () {
                $('#hilx-header').addClass('white-header');
            });


        }

        if ($(this).scrollTop() <= 0) {
            $('#hilx-announcement-bar').slideDown(200, function () {
                if (isHomePage()) {
                    $('#hilx-header').removeClass('white-header');
                }
            });

        }
    }
    if (isInnovationPage()) {
        if ($(this).scrollTop() <= 0) {
            $('#hilx-header').addClass('transparent-header');
            $('sticky-header').css('top', 'unset');
        }
        else {
            $('#hilx-header').removeClass('transparent-header');
            $('sticky-header').css('top', 0);
        }
    }
});
function initLang() {
    $('div.tl-language').find('img.tl-flag').each(function (index, obj) {
        var tempImgSrc = $(obj).attr('src');
        if (tempImgSrc && tempImgSrc.indexOf('tw.svg') !== -1) {
            tempImgSrc = tempImgSrc.replace('tw.svg', 'hk.svg');
            $(obj).attr('src', tempImgSrc)
        }
    })
    $('.language-switcher-custom').show();
    var tid = setInterval(function () {
        $(`.hilx_loading`).css(`display`, `none`);
        clearInterval(tid);
    }, 100);

    $(document).ready(function () {
        $(`.hilx_loading`).css(`display`, `none`);
    });
}
function updateHeaderBg() {
    try {
        if ($('#hilx-header').length > 0) {
            $('#hilx-header').find('.mega-menu__content').removeClass('is-hover');
            $('.header__menu-item').removeClass('is-hover');
            if ($(document).scrollTop() <= 0) {
                if (isHomePage()) {
                    $('#hilx-header').removeClass('white-header');
                }
            }
            else {
                $('#hilx-header').addClass('white-header');
            }
        }
    }
    catch (e) {
        console.log('[Error] updateHeaderBg')
    }
}

function isHomePage() {
    try {
        var pageType = meta;
        if (pageType && pageType.page && pageType.page.pageType && pageType.page.pageType == 'home') {
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
}
function isInnovationPage() {
    if ($('.len-technology-page').length > 0 || $('.frame-designs').length > 0) {
        return true;
    }
    return false;
}
function initTooltip() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

function handlerMenu() {
    if (!isHomePage()) {
        $('#hilx-header').addClass('white-header');
    }
    if (isInnovationPage()) {
        $('#hilx-header').addClass('transparent-header');
    }
    $('.mega_menu-item-level-1').find('.toggle-child').click(function () {
        var parent = $(this).parents('.mega-menu__content');
        $(parent).find('.mega_menu-item-level-2').removeClass('active');
        $(parent).find('.mega_menu-item-level-1').find('.toggle-child').removeClass('active');
        var child = $(this).data('child');
        $(this).addClass('active');
        $('#' + child).addClass('active');
        var type = $('#' + child).data('type');
        // if(type=='custom')
        // {
        // 	$('.mega_menu-col-best-seller').hide();
        // 	$('#'+child).parent('.mega_menu-col').removeClass('col-8').addClass('col-10');
        // }
        // else{
        // 	$('.mega_menu-col-best-seller').hide();
        // 	$('#'+child).parent('.mega_menu-col').removeClass('col-10').addClass('col-8');
        // }
    })

    if ($('.menu-collection-container').length > 0) {
        var currentContent = $('.menu-collection-container').html();
        if (currentContent.length <= 10) {
            var tempHTML = $('.menu-collection-section').html();
            $('.menu-collection-container').html(tempHTML);
            $('.menu-collection-section').html("");
        }
    }

    if ($('.mobile-mega-menu__collection').length > 0) {
        var currentContent = $('.mobile-mega-menu__collection').html();
        if (currentContent.length <= 10) {
            var tempHTML = $('.menu-collection-section-mobile').html();
            $('.mobile-mega-menu__collection').html(tempHTML);
            $('.menu-collection-section-mobile').html("");
        }
    }

    if ($('.menu-sport-container').length > 0) {
        var currentContent = $('.menu-sport-container').html();
        if (currentContent.length <= 10) {
            var tempHTML = $('.menu-sport-section').html();
            $('.menu-sport-container').html(tempHTML);
            $('.menu-sport-section').html("");
        }
    }

    if ($('.mobile-mega-menu__sport').length > 0) {
        var currentContent = $('.mobile-mega-menu__sport').html();
        if (currentContent.length <= 10) {
            var tempHTML = $('.menu-sport-section-mobile').html();
            $('.mobile-mega-menu__sport').html(tempHTML);
            $('.menu-sport-section-mobile').html("");
        }
    }

    if ($('.submenu-lvl-1').length > 0) {
        $('.submenu-lvl-1').click(function (event) {
            if ($(this).hasClass('is-parent-true')) {
                var parrent = $(this).find('.mobile_mega_menu-wrapper');
                if ($('#' + parrent.attr('id')).hasClass('is-active')) {
                    if ($(event.target).hasClass('sub-title') || $(event.target).hasClass('sub-menu-title')) {
                        $('#' + parrent.attr('id')).removeClass('is-active');
                    }

                }
                else if ($(event.target).hasClass('link-lv1') || $(event.target).hasClass('submenu-lvl-1')) {
                    $('#' + parrent.attr('id')).addClass('is-active');

                }

            }
        });
        if ($('.submenu-lvl-2').length > 0) {
            $('.submenu-lvl-2').click(function (event) {
                if ($(this).hasClass('is-parent-true')) {
                    var parrent = $(this).find('.mobile_mega_menu-wrapper');
                    if ($('#' + parrent.attr('id')).hasClass('is-active')) {
                        if ($(event.target).hasClass('sub-title-lv2') || $(event.target).hasClass('sub-menu-title-lv2')) {
                            $('#' + parrent.attr('id')).removeClass('is-active');
                        }

                    }
                    else if ($(event.target).hasClass('link-lv2') || $(event.target).hasClass('submenu-lvl-2')) {
                        $('#' + parrent.attr('id')).addClass('is-active');

                    }
                }
            })
        }
    }

    window.memberTierUpdate = function (tier) {
        var icon = ''
        if (tier == 'bronze') {
            icon = '<i class="icon-bronze fas fa-award fa-4x mb-2"></i>'
        }
        else if (tier == 'silver') {
            icon = '<i class="icon-silver fas fa-medal fa-4x mb-2"></i>'
        }
        else if (tier == 'gold') {
            icon = '<i class="icon-gold fas fa-trophy fa-4x mb-2"></i>'
        }

        Swal.fire({
            html: `<div class="pt-3">${icon}<h2 class="mt-3">${window.congratulationsString.congratulations}</h2><p">${window.congratulationsString.congratulations_text}</p></div>`,
            confirmButtonText: window.congratulationsString.continue,
            customClass: {
                confirmButton: 'btn btn-dark btn-lg',
                container: 'member-tier-change'
            }
        });
    }
    window.memberTierDowngrade = function (tier) {
        var icon = ''
        if (tier == 'bronze') {
            icon = '<i class="icon-bronze fas fa-award fa-4x mb-2"></i>'
        }
        else if (tier == 'silver') {
            icon = '<i class="icon-silver fas fa-medal fa-4x mb-2"></i>'
        }
        else if (tier == 'gold') {
            icon = '<i class="icon-gold fas fa-trophy fa-4x mb-2"></i>'
        }
        else {
            icon = '<i class="fa-regular fa-face-frown-open"></i>'
        }
        Swal.fire({
            html: `<div class="pt-3">${icon}<h2 class="mt-3">${window.congratulationsString.congratulations}</h2><p">${window.congratulationsString.congratulations_text}</p></div>`,
            confirmButtonText: window.congratulationsString.continue,
            customClass: {
                confirmButton: 'btn btn-dark btn-lg',
                container: 'member-tier-change'
            }
        });
    }
}
/**
   * Copy text to clipboard
   * @param {string} text - Text to be copied
   */
function copyToClipboard(text) {
    const tempInput = document.createElement('input');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    Toastify({
        text: window.rewardStrings.copy_to_clipboard,
        className: "success",
        gravity: "bottom",
        position: "center",
        style: {
            background: "#d2ff02",
            color: "#000",
            fontSize: '11px'
        }
    }).showToast();
}